var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.titleEnabled
    ? _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12 text-center" }, [
          _c("h1", [
            _vm._v("\n      " + _vm._s(_vm.T.siteTitle[_vm.lang]) + "\n      "),
            _vm.lang !== "en"
              ? _c(
                  "button",
                  {
                    attrs: { type: "button", title: "Switch to English" },
                    on: {
                      click: function($event) {
                        return _vm.switchLanguage("en")
                      }
                    }
                  },
                  [_vm._v("🇬🇧")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.lang !== "hu"
              ? _c(
                  "button",
                  {
                    attrs: { type: "button", title: "Váltás magyar nyelvre" },
                    on: {
                      click: function($event) {
                        return _vm.switchLanguage("hu")
                      }
                    }
                  },
                  [_vm._v("🇭🇺")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "h1",
            _vm._l(_vm.YEARS, function(y) {
              return _c(
                "a",
                {
                  key: y,
                  staticClass: "badge mr-2",
                  class: _vm.getClass(y),
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.yearChanged(y)
                    }
                  }
                },
                [_vm._v(_vm._s(y === 2025 ? y + ".07" : y))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("br")
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a97c0b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a97c0b5","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/Title.vue
// module id = 19
// module chunks = 0